import axios from 'axios';
import { demoStore, isDemoModeActive } from './demoModeService';

const demoClinicAdapter = async (config: any) => {
  const method = String(config.method || 'get').toLowerCase();
  const url = String(config.url || '').split('?')[0];
  let payload = config.data;
  if (typeof payload === 'string') { try { payload = JSON.parse(payload); } catch {} }
  let response: any = {};
  const state = demoStore.mutate(() => {});

  const effectiveMatch = url.match(/^\/chat\/chat-sessions\/([^/]+)\/bot-effective$/);
  const overrideMatch = url.match(/^\/chat\/chat-sessions\/([^/]+)\/bot-override$/);
  const conversationsMatch = url.match(/^\/clinics\/patients\/(\d+)\/chat\/conversations$/);
  const conversationMatch = url.match(/^\/clinics\/patients\/(\d+)\/chat\/conversations\/(\d+)$/);
  const conversationMessagesMatch = url.match(/^\/clinics\/patients\/(\d+)\/chat\/conversations\/(\d+)\/messages$/);
  const patientBindingMatch = url.match(/^\/clinics\/patients\/(\d+)\/chat-bindings$/);
  if (effectiveMatch) {
    const thread = state.threads.find(item => item.id === effectiveMatch[1]);
    response = { bot_enabled: thread?.bot_enabled ?? true, selected_bot_id: thread?.selected_bot_id ?? 1, escalated_to_human: !!thread?.escalated_to_human, escalation_reason: thread?.escalation_reason ?? null, appointment_booked: !!thread?.appointment_booked, effective_bot: { id: 1, name: 'Asistente Clínica', bot_type: 'clinic', pricing_type: 'premium' }, default_bot: { id: 1 } };
  } else if (overrideMatch) {
    demoStore.mutate(data => {
      const thread = data.threads.find(item => item.id === overrideMatch[1]);
      if (!thread) return;
      Object.assign(thread, {
        bot_enabled: payload?.bot_enabled ?? thread.bot_enabled,
        selected_bot_id: payload?.selected_bot_id ?? thread.selected_bot_id,
        appointment_booked: payload?.appointment_booked ?? thread.appointment_booked,
      });
      if (payload?.escalated_to_human === true) {
        thread.escalated_to_human = true;
        thread.escalation_reason = 'Intervención humana solicitada';
        thread.bot_enabled = false;
      } else if (payload?.escalated_to_human === false || payload?.bot_enabled === true) {
        thread.escalated_to_human = false;
        thread.escalation_reason = null;
      }
    });
    response = { success: true };
  } else if (conversationMessagesMatch) {
    response = method === 'get' ? { messages: [], total: 0, page: 1, per_page: 0 } : { id: Date.now(), conversation_id: Number(conversationMessagesMatch[2]), role: 'user', content: payload?.content || '', created_at: new Date().toISOString() };
  } else if (conversationMatch) {
    response = { id: Number(conversationMatch[2]), patient_id: Number(conversationMatch[1]), title: payload?.title || 'Consulta demo', is_saved: !!payload?.is_saved, created_at: new Date().toISOString(), updated_at: new Date().toISOString(), message_count: 0 };
  } else if (conversationsMatch) {
    const conversation = { id: 8600 + Number(conversationsMatch[1]), patient_id: Number(conversationsMatch[1]), title: payload?.title || 'Consulta demo', is_saved: false, created_at: new Date().toISOString(), updated_at: new Date().toISOString(), message_count: 0 };
    response = method === 'get' ? { conversations: [conversation], total: 1, page: 1, per_page: 1 } : conversation;
  } else if (patientBindingMatch) {
    demoStore.mutate(data => {
      const patient = data.patients.find(item => item.id === Number(patientBindingMatch[1]));
      const thread = data.threads.find(item => String(item.customer_id) === String(payload?.chat_customer_id));
      if (patient && thread) thread.patient = { id: patient.id, full_name: patient.full_name, phone: patient.phone };
    });
    response = { success: true };
  } else if (url === '/clinics/dashboard') {
    response = { stats: { total_patients: state.patients.length, active_patients: state.patients.length, total_appointments: state.appointments.length, appointments_today: 1, pending_appointments: state.appointments.filter(a => a.status === 'pending').length, new_patients_today: 1 }, recent_patients: state.patients.slice(0, 5).map(p => ({ id: p.id, full_name: p.full_name, status: p.status, diagnosis: null, last_visit: p.last_appointment_date, next_appointment: p.next_appointment_date })) };
  } else if (url === '/clinics/rooms' && method === 'get') response = state.rooms;
  else if (url === '/clinics/rooms' && method === 'post') {
    demoStore.mutate(data => { response = { id: `demo-room-${demoStore.nextId(data)}`, ...payload }; data.rooms.push(response); });
  } else if (/^\/clinics\/rooms\//.test(url)) {
    const id = url.split('/').pop(); demoStore.mutate(data => { const room = data.rooms.find(r => String(r.id) === id); if (room) Object.assign(room, payload); response = room; });
  } else if (url === '/clinics/patients' && method === 'get') {
    let patients = state.patients; const q = String(config.params?.search || '').toLowerCase(); if (q) patients = patients.filter(p => p.full_name.toLowerCase().includes(q));
    response = { patients, total: patients.length, page: 1, per_page: patients.length };
  } else if (url === '/clinics/patients' && method === 'post') {
    demoStore.mutate(data => { const now = new Date().toISOString(); response = { id: demoStore.nextId(data), email: null, phone: null, date_of_birth: null, gender: null, blood_type: null, allergies: null, chronic_conditions: null, emergency_contact_name: null, emergency_contact_phone: null, insurance_provider: null, insurance_policy_number: null, address: null, status: 'active', notes: null, avatar_url: null, registration_date: now, created_at: now, updated_at: now, last_appointment_date: null, next_appointment_date: null, appointment_count: 0, ...payload }; data.patients.push(response); });
  } else if (/^\/clinics\/patients\/\d+$/.test(url)) {
    const id = Number(url.split('/').pop());
    if (method === 'get') response = state.patients.find(p => p.id === id);
    else demoStore.mutate(data => { const index = data.patients.findIndex(p => p.id === id); if (method === 'delete') data.patients.splice(index, 1); else { Object.assign(data.patients[index], payload); response = data.patients[index]; } });
  } else if (url === '/clinics/appointments' && method === 'get') {
    let appointments = state.appointments;
    if (config.params?.patient_id) appointments = appointments.filter(a => a.patient_id === Number(config.params.patient_id));
    if (config.params?.date_from) appointments = appointments.filter(a => a.start_time >= config.params.date_from);
    if (config.params?.date_to) appointments = appointments.filter(a => a.start_time <= `${config.params.date_to}T23:59:59`);
    response = { appointments, total: appointments.length, page: 1, per_page: appointments.length };
  } else if (url === '/clinics/appointments' && method === 'post') {
    demoStore.mutate(data => { const now = new Date().toISOString(); response = { id: demoStore.nextId(data), created_at: now, updated_at: now, ...payload }; response.patient_name = data.patients.find(p => p.id === response.patient_id)?.full_name; response.doctor_name = data.doctors.find(d => d.id === response.doctor_id)?.name; data.appointments.push(response); });
  } else if (/^\/clinics\/appointments\/\d+$/.test(url)) {
    const id = Number(url.split('/').pop()); demoStore.mutate(data => { const index = data.appointments.findIndex(a => a.id === id); if (method === 'delete') data.appointments.splice(index, 1); else { Object.assign(data.appointments[index], payload, { updated_at: new Date().toISOString() }); response = data.appointments[index]; } });
  } else if (url === '/clinics/doctors' && method === 'get') response = { doctors: state.doctors, total: state.doctors.length, page: 1, per_page: state.doctors.length };
  else if (url === '/clinics/doctors' && method === 'post') demoStore.mutate(data => { const now = new Date().toISOString(); response = { id: demoStore.nextId(data), workdays: [], vacations: [], created_at: now, updated_at: now, ...payload }; data.doctors.push(response); });
  else if (/^\/clinics\/doctors\/\d+$/.test(url)) {
    const id = Number(url.split('/').pop()); demoStore.mutate(data => { const index = data.doctors.findIndex(d => d.id === id); if (method === 'delete') data.doctors.splice(index, 1); else { Object.assign(data.doctors[index], payload); response = data.doctors[index]; } });
  } else if (url.endsWith('/files') || url.endsWith('/folders')) response = [];
  else if (url.includes('/chat/conversations') && url.endsWith('/messages')) response = { messages: [], total: 0, page: 1, per_page: 0 };
  else if (url.includes('/chat/conversations')) response = { conversations: [], total: 0, page: 1, per_page: 0 };
  else if (url.includes('/rag/summary')) response = { summary: 'Resumen sintético del paciente para la sesión de demostración.' };
  else if (url.includes('/stats')) response = { total_messages: 18, total_user_messages: 11, total_assistant_messages: 7, total_threads: 6, active_threads: 6, avg_messages_per_patient: 3, avg_operator_response_time_ms: 42000, timeline: [], top_patients: [] };
  else response = method === 'get' ? [] : { success: true };

  return { data: response, status: 200, statusText: 'OK', headers: {}, config };
};

// When running via Docker, requests go through Nginx (same origin) at /api.
// For local dev, set VITE_CLINICS_API_URL=http://localhost:8001/api in .env
const CLINICS_API_URL = import.meta.env.VITE_CLINICS_API_URL || '/api/v1';

const clinicsApi = axios.create({
  baseURL: CLINICS_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach JWT token
clinicsApi.interceptors.request.use(
  (config) => {
    // The existing Express backend and new FastAPI backend share the same JWT
    const token = localStorage.getItem('jwtToken');
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (isDemoModeActive() && ['/clinics/', '/chat/'].some(prefix => String(config.url || '').startsWith(prefix))) config.adapter = demoClinicAdapter;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle generic errors (like 401/403)
clinicsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token is invalid or expired
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('comercio_key');
      // Let the main app router handle redirection to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default clinicsApi;
